import { Controller } from "@hotwired/stimulus";

// The Trade window searches as the customer types
export default class extends Controller {
  static targets = ["form", "input", "submit"];

  connect() {
    this.modal = this.element.closest(".modal");
    this.focus = () => this.inputTarget.focus();
    this.modal?.addEventListener("shown.bs.modal", this.focus);
  }

  disconnect() {
    clearTimeout(this.timeout);
    this.modal?.removeEventListener("shown.bs.modal", this.focus);
  }

  search() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.submit(), 250);
  }

  submit() {
    clearTimeout(this.timeout);
    // A click goes through Turbo in every browser, unlike requestSubmit
    this.submitTarget.click();
  }
}
